module.exports = Em.Handlebars.compile("{{#each type in types}}\n    {{view itemViewClass initialValueBinding=\"value\" typeBinding=\"type\"}}\n{{/each}}");